import React from 'react'
import Button from '../../../../../ui/Button/Button'
import { PRODUCTS_ACTIVE_FILTER, PRODUCTS_TAXONOMY_FILTER } from './filterProductsByTableFilters'

const TAXONOMY_OPTIONS = [
  { value: PRODUCTS_TAXONOMY_FILTER.all, label: 'Усі' },
  { value: PRODUCTS_TAXONOMY_FILTER.missingMain, label: 'Без основної категорії' },
  { value: PRODUCTS_TAXONOMY_FILTER.assigned, label: 'Категоризовані' },
]

const ACTIVE_OPTIONS = [
  { value: PRODUCTS_ACTIVE_FILTER.all, label: 'Усі' },
  { value: PRODUCTS_ACTIVE_FILTER.active, label: 'Активні' },
  { value: PRODUCTS_ACTIVE_FILTER.inactive, label: 'Неактивні' },
]

function FilterGroup({ label, value, options, onChange }) {
  return (
    <div className="ProductsTableFilters-Group">
      <span className="ProductsTableFilters-Label">{label}</span>
      <div className="ProductsTableFilters-Options">
        {options.map((option) => {
          const isActive = option.value === value
          return (
            <Button
              key={option.value}
              title={option.label}
              theme="solid"
              fill={isActive ? 'accent' : 'normal'}
              size={32}
              onClick={() => onChange(option.value)}
            />
          )
        })}
      </div>
    </div>
  )
}

function ProductsTableFilters({ taxonomyFilter, activeFilter, onChange }) {
  return (
    <div className="ProductsTableFilters">
      <FilterGroup
        label="Категорії"
        value={taxonomyFilter}
        options={TAXONOMY_OPTIONS}
        onChange={(next) => onChange({ taxonomyFilter: next })}
      />
      <FilterGroup
        label="Статус"
        value={activeFilter}
        options={ACTIVE_OPTIONS}
        onChange={(next) => onChange({ activeFilter: next })}
      />
    </div>
  )
}

export default ProductsTableFilters
